import * as R from 'ramda';
import { mergeStyles } from '../../../../internal/utils/mergeStyles';
import * as mainStyles from './styles.css';
import { getDeviceStyles, getDeviceStylesIdentity } from './device';
function getRadioStyles(deviceType) {
  var deviceStyles = getDeviceStyles(deviceType);
  return mergeStyles(mainStyles, deviceStyles);
}
export var getStyles = R.memoizeWith(getDeviceStylesIdentity, getRadioStyles);